import React, { FC } from 'react';

import styled from 'styled-components';

import { ErrorViewModel } from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';

const ErrorMessageWrapper = styled.span`
  width: 100%;
  height: 45px;
  margin-top: 17px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  background-color: rgba(224, 35, 27, 0.1);
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  margin-left: 5px;
  margin-top: 1px;
`;

interface Props {
  errors: ErrorViewModel[];
}

const ErrorMessages: FC<Props> = ({ errors }) => (
  <>
    {errors.map((error) => (
      <ErrorMessageWrapper key={error.title}>
        <CustomIcon icon={InfoIcon} paletteColor='coral' fontSize={15} />

        <ErrorMessage>{error.detail}</ErrorMessage>
      </ErrorMessageWrapper>
    ))}
  </>
);

export default ErrorMessages;
